var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isActive)?_c('div',[_c('div',{staticClass:"card mb-4"},[_c('div',{staticClass:"card-header"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"card-body"},[_vm._t("default")],2)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }